import React, { FC } from 'react';
import { Avatar } from 'components/Avatar';
import { IUser } from 'common/types/user.types';
import { getUserName } from 'common/helpers/user.helper';

interface IComponentProps {
  label: string;
  users?: IUser[];
  onUserClick: (value: IUser) => void;
}

export const Users: FC<IComponentProps> = ({ label, users, onUserClick }) => {
  return (
    <div className="users">
      <div className="users__label">{label}</div>

      <div className="users__scroll">
        {users?.map((user) => {
          return (
            <button key={user.id} className="users__item" onClick={() => onUserClick(user)}>
              <Avatar url={user.avatar} className="users__item-avatar" />

              <div className="users__item-name">{getUserName(user.firstname, user.lastname)}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
